import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import {
    ContractTypeDistribution,
    DemographicInsights,
    AgeRangeDistribution,
    SalaryRangeDistribution,
    SeniorityDistribution,
    DepartmentTypeDistribution,
    AverageCompanyTime,
    CompanyTimeRanges
} from '../../Indicators';

export default function CollaboratorIndicatorsPage() {
    return (
        <div className="space-y-6">
            {/* Data Disclaimer Alert */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex">
                    <div className="flex-shrink-0">
                        <InformationCircleIcon className="h-5 w-5 text-blue-400" aria-hidden="true" />
                    </div>
                    <div className="ml-3">
                        <p className="text-sm text-blue-700">
                            <strong>Aviso:</strong> Os dados apresentados nesta página são simulados e não representam informações reais dos colaboradores. Servem apenas para demonstração dos indicadores.
                        </p>
                    </div>
                </div>
            </div>

            {/* First Row - Contract & Demographics */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                <ContractTypeDistribution />
                <DemographicInsights />
            </div>

            {/* Second Row - Age, Salary & Seniority */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                <AgeRangeDistribution />
                <SalaryRangeDistribution />
                <SeniorityDistribution />
            </div>

            {/* Third Row - Department Type, Company Time & Time Ranges */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                <DepartmentTypeDistribution />
                <AverageCompanyTime />
                <CompanyTimeRanges />
            </div>
        </div>
    );
} 